'use strict';


export default function($animateCss) {
	'ngInject';

	return {
		beforeAddClass: add,
		beforeRemoveClass: remove,
	};

	function add(element, className, done) {
		console.log('test');
		done();
	}

	function remove(element, className, done) {
		console.log('test');
		done();
	}
}
